import { render, staticRenderFns } from "./Materials.vue?vue&type=template&id=08f41162&scoped=true&"
import script from "./Materials.vue?vue&type=script&lang=js&"
export * from "./Materials.vue?vue&type=script&lang=js&"
import style0 from "./Materials.vue?vue&type=style&index=0&id=08f41162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f41162",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08f41162')) {
      api.createRecord('08f41162', component.options)
    } else {
      api.reload('08f41162', component.options)
    }
    module.hot.accept("./Materials.vue?vue&type=template&id=08f41162&scoped=true&", function () {
      api.rerender('08f41162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Materials.vue"
export default component.exports